import React from 'react'

const organizationContext = React.createContext({});

export { organizationContext }
